import { AxiosResponse } from 'axios'
import { SetStateAction } from 'react'
import { APIDecoratorWithBaseURI } from '../../Service/api'

export interface RefreshResponseData {
  success?: boolean
  error?: boolean
  message?: string
  errorCode?: string
  data?: {
    accessToken: string
  }
}

export const refreshTokenDestroy = async (): Promise<
  SetStateAction<string | void>
> => {
  const response = await APIDecoratorWithBaseURI(
    process.env.REACT_APP_API_AUTH
  ).get<String, AxiosResponse<RefreshResponseData>>(
    `auth/dashboard/producer/logout`,
    {
      responseType: 'json',
      headers: { 'content-type': 'application/json' },
      withCredentials: true,
    }
  )

  if (response.data !== undefined) {
    log?.success({ log: 'Cookie Destroyed', data: response.data })
  }
}
